var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:confirmation-number"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5413 8.85413H11.458V6.77079H13.5413V8.85413ZM13.5413 13.5416H11.458V11.4583H13.5413V13.5416ZM13.5413 18.2291H11.458V16.1458H13.5413V18.2291ZM22.9163 10.4166V6.24996C22.9163 5.69742 22.6968 5.16752 22.3061 4.77682C21.9154 4.38612 21.3855 4.16663 20.833 4.16663H4.16634C3.61381 4.16663 3.0839 4.38612 2.6932 4.77682C2.3025 5.16752 2.08301 5.69742 2.08301 6.24996V10.4166C2.63554 10.4166 3.16545 10.6361 3.55615 11.0268C3.94685 11.4175 4.16634 11.9474 4.16634 12.5C4.16634 13.0525 3.94685 13.5824 3.55615 13.9731C3.16545 14.3638 2.63554 14.5833 2.08301 14.5833V18.75C2.08301 19.3025 2.3025 19.8324 2.6932 20.2231C3.0839 20.6138 3.61381 20.8333 4.16634 20.8333H20.833C21.3855 20.8333 21.9154 20.6138 22.3061 20.2231C22.6968 19.8324 22.9163 19.3025 22.9163 18.75V14.5833C22.3638 14.5833 21.8339 14.3638 21.4432 13.9731C21.0525 13.5824 20.833 13.0525 20.833 12.5C20.833 11.9474 21.0525 11.4175 21.4432 11.0268C21.8339 10.6361 22.3638 10.4166 22.9163 10.4166Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuban);
export default __webpack_public_path__ + "static/media/nuban.93b70f7b91c4f485bfa8f75537a595b0.svg";
export { ForwardRef as ReactComponent };